module.exports = __webpack_public_path__ + "img/lngcng.db3cbd95.svg";